import React from 'react';
import { Fade, Box } from '@mui/material';

interface PageTransitionProps {
  children: React.ReactNode;
  in?: boolean;
}

const PageTransition: React.FC<PageTransitionProps> = ({ children, in: inProp = true }) => {
  return (
    <Fade in={inProp} timeout={500}>
      <Box>{children}</Box>
    </Fade>
  );
};

export default PageTransition;